import _ from 'lodash';
import { initDycolor, storeGetters, NotFound, Loading } from '~';
import Campaign from '@/components/rabbit/campaign/Campaign.vue';
import { mapActions, mapState } from 'vuex';

initDycolor('campaign-wrapper', require(`${process.env.DYCOLOR_REQUIRE}./CampaignWrapper.scss`)); // eslint-disable-line

export default {
  components: {
    Loading,
    Campaign,
    NotFound,
  },
  computed: {
    ...mapState('genericConfig', {
      loadingConfig: 'loading',
    }),
    ...mapState('campaign', {
      loadingCampaign: 'loading',
      error: 'error',
      campaign: 'current',
    }),
    loading() {
      return this.loadingConfig || this.loadingCampaign;
    },
    mapPreview() {
      return _.get(this.campaign, 'map_images.0.path', null);
    },
    notFound() {
      return this.error && [404, 403].includes(this.error.code);
    },
  },
  methods: {
    ...mapActions('campaign', ['getCampaign']),
    ...mapActions('genericConfig', ['updateConfig']),
    fetchData() {
      this.getCampaign(storeGetters.getRouterParams().code);
    },
  },
  mounted() {
    this.updateConfig();
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign-wrapper/CampaignWrapper.js